var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.29,9.55a3.75,3.75,0,0,0-4.58,0L9.48,37.21a3.77,3.77,0,0,0-.71,5.28h0a3.77,3.77,0,0,0,5.29.71l3.75-2.87V83.27a3.78,3.78,0,0,0,3.78,3.78H74.42a3.77,3.77,0,0,0,3.77-3.78V40.33L82,43.19a3.76,3.76,0,0,0,5.26-.7h0a3.77,3.77,0,0,0-.71-5.28Zm20.36,70H25.36V34.59L48,17.31,70.65,34.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M44.23,56.86V79.5h7.55V56.86Zm-3.77-7.55a3.77,3.77,0,0,0-3.78,3.77v34H59.32v-34a3.77,3.77,0,0,0-3.77-3.77Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    isolate: "isolate",
    opacity: 0.01,
    className: "cls-2",
    width: 96,
    height: 96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c9d359d61d87a2cc7e0fc4958aa1d46c.svg";
export { ForwardRef as ReactComponent };